const useFormattedUserName = () => {
  const userNameRaw = sessionStorage.getItem("userName") || "Learner";
  let userName = userNameRaw;
  let firstName = "";

  if (userNameRaw.includes(",")) {
    const [last, first] = userNameRaw.split(",").map((s) => s.trim());
    const cap = (str: string) =>
      str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
    firstName = cap(first);
    userName = `${cap(first)} ${cap(last)}`;
  }

  return { firstName, userName };
};

export default useFormattedUserName;
